import * as React from "react";
import './index.css';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';

const NotFoundPage = () => {
	const history = useHistory();

	return <div id="notfound">
		<div class="notfound">
			<div class="notfound-404"></div>
			<h1>500</h1>
			<h2>Oops! Internal Server Error</h2>
			<p>Sorry, something went wrong on our end. Please contact your administrator</p>
			<Button
				//className={classes.navItemButton}
				id="transfer-button"
				variant="text"
				disableRipple
				onClick={() => history.push("/")}
			>
				Back to homepage
                        </Button>
		</div>
	</div>;
}

export default NotFoundPage;